<template>
  <v-layout row wrap pt-4>
    <v-flex md8 xs12 pt-2>
      <v-layout row wrap>
        <v-flex sm12>
          <h2>{{ post_video.title }}</h2>
          <post-main-video :video_source="post_video.file_video" :image_source="post_video.main_image" />
        </v-flex>
        <v-flex sm12>
          <v-card>
            <v-flex pa-4>
              <post-content :content="post_video.content" :published_date="post_video.published_at" :post_type="post_video.post_type" />
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex sm4 pl-4 hidden-sm-and-down>
      <post-video-related :relatedPosts="post_video.relationed_posts" />
    </v-flex>
    <!-- <v-flex sm12 pt-4>
      <gallery :postId="post_video.id" :key="post_video.id" />
    </v-flex> -->
    <v-layout justify-center>
      <v-flex>
        <button-return route_name="momentos-security" link_name="Momentos Security" />
        <v-btn
          v-if="current_user.role.includes('admin')"
          color="warning"
          :href="post_video.url"
          target="_blank"
        >Editar</v-btn>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import Gallery from "@/components/General/Gallery";
import PostMainVideo from "./PostMainVideo"
import PostContent from "./PostContent";
import PostVideoRelated from "./PostVideoRelated";
import ButtonReturn from "./ButtonReturn";

let style = ["transparent", "red lighten-2", "orange lighten-3"];
export default {
  props: {
    post_video: {
      type: Object,
      required: true
    }
  },
  components: {
    Gallery,
    PostContent,
    PostVideoRelated,
    PostMainVideo,
    ButtonReturn
  },
  computed: {
    ...mapState("user", ["current_user"])
  }
};
</script>